<i class="fa" [ngClass]="iconClass" (click)="copyContent()"></i>


// WEBPACK FOOTER //
// ./src/app/shared/copy-clipboard/copy-clipboard.component.html